import React, { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { Row, Column, RowToColumn } from "./Layout";
import { Button, Anchor } from "./Button";
import { Input } from "./Input";
import { Label, H4 } from "./Typography";
import { isValidEmail, logAnalyticEvent, getUrlParams } from "../utils";
import { getUserByEmail } from "../store/queries/user";
import { Checkbox } from "./Toggle";
import { settingsActions } from "../store/actions";
import { device } from "../utils/variables";

const Form = styled.form`
  display: flex;
  margin: 0 -20px -100px;
  @media ${device.mobileL} {
    margin: 0;
  }
`;

const InputWrapper = styled.div`
  .input-wrapper {
    background: rgba(255, 255, 255, 0.25);

    input,
    input::placeholder {
      color: white;
    }
  }
`;

export const SubscribeBanner = ({
  events,
  oncoalert = false,
  handlePreviousPage,
}) => {
  const auth = useSelector((state) => state.auth.data);
  const queryParams = getUrlParams(location.search);

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [agree, setAgree] = useState(true);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const submit = (e) => {
    e.preventDefault();
    if (isValidEmail(email)) {
      if (oncoalert) {
        // store current page if oncoalert, as we need to return after signup
        handlePreviousPage();
      }
      logAnalyticEvent(
        "Subscribe",
        {
          page: events?.page,
          ...(events?.name && { name: events.name }),
          email,
        },
        auth?.id || queryParams?.u || null,
        auth?.displayName || queryParams?.n || null,
        auth?.email || queryParams?.e || null,
        auth?.createdAt || null,
        auth?.preferences?.filter((p) => p.preferenceName === "UserType")?.[0]
          ?.preferenceStringValue ||
          queryParams?.t ||
          "MEDICAL",
        null
      );
      getUserByEmail(email).then((userResp) => {
        if (userResp.data?.id) {
          setError(
            "This email already exists. Please use the 'Sign in' link below"
          );
        } else {
          // user not found, so we can proceed with signup
          let url = "/signup?email=" + encodeURIComponent(email);
          if (oncoalert) {
            url += "&oncoalert=true";
          }
          window.location.href = url;
        }
      });
    } else {
      setError("Invalid email");
    }
  };

  return (
    <Form onSubmit={(e) => submit(e)}>
      <Column
        bkg={oncoalert ? "blue" : "green"}
        fade="8"
        paddingX="40"
        paddingY="60"
        gap="40"
      >
        <Column gap="10">
          <H4 bold color="white">
            Want practice changing updates in oncology/hematology?
          </H4>
          {oncoalert ? (
            <Label large color="blue" fade="2">
              Get our weekly newsletter. 🙂
            </Label>
          ) : (
            <Label large color="green" fade="2">
              Get our weekly newsletter and join 2400+ clinicians. 🙂
            </Label>
          )}
        </Column>
        <Checkbox
          light
          checked={agree}
          label="I agree to receiving scientific, non-promotional materials from OncoAlert and Medical.watch"
          onChange={() => setAgree(!agree)}
          errorMessage={!agree && "Agree to our terms to subscribe"}
        />
        <Column gap="20">
          <InputWrapper>
            <Input
              light
              errorTop
              expand
              placeholder="Enter email"
              value={email}
              onChange={handleEmailChange}
              errorMessage={error}
            />
          </InputWrapper>
          <RowToColumn gap="20" columnGap="10" device="mobileL">
            <Button
              large
              color={oncoalert ? "blue" : undefined}
              secondary
              type="submit"
              label="Subscribe for free"
              onClick={(e) => submit(e)}
            />
            {!oncoalert && (
              <Row middle gap="10">
                <Label color="green" fade="2">
                  Existing user?
                </Label>
                <Anchor color="white" bold to="/login" label="Sign in" />
              </Row>
            )}
          </RowToColumn>
        </Column>
      </Column>
    </Form>
  );
};
